import chenHuifen from "@assets/events-awards/sia/chen-huifen.png";
import drAmyKhor from "@assets/events-awards/sia/dr_amy_khor.jpg";
import elizaTan from "@assets/events-awards/sia/eliza_tan_sgx.jpg";
import geoffrey from "@assets/events-awards/sia/geoffrey-yeo_0.jpg";
import lawrence from "@assets/events-awards/sia/lawrence-loh.png";
import theresa from "@assets/events-awards/sia/theresa-goh.png";
import tanSeeYiow from "@assets/events-awards/sia/tsy.jpg";
import { BlockTitle } from "@blocks/Blocks";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";
import Column from "@src/app/components/Grid/Column";
import Row from "@src/app/components/Grid/Row";

/**
 * Component to render SIA judges page
 */
const SIAJudgesPage = (): React.ReactElement => {
  return (
    <div
      data-testid="event-awards-sia-judges-component"
      className="font-public-sans"
    >
      <BlockTitle
        text="Judges"
        rootClassName="my-3 mb-6 text-3xl md:text-5xl lg:text-6xl font-medium font-public-sans"
      />

      <AccordionV2
        testId="judges-drAmyKhor-accordion"
        className="rounded-tl-lg rounded-tr-lg border border-gray-175 bg-gray-150 py-4"
        headerChildren={<EventsAwardsAccordionHeader title="Dr Amy Khor" />}
        arrowClassName="border-none h-auto w-auto pr-6"
      >
        <Row rootClassName="flex flex-col md:flex-row w-full pt-4 mt-4 border-t border-gray-175 px-6 mx-0">
          <Column rootClassName="w-2/3 md:w-2/12 px-0 md:pr-3">
            <img src={drAmyKhor} alt="Dr Amy Khor" />
          </Column>

          <Column rootClassName="md:w-10/12 px-0 pt-4 md:pt-0 md:pl-3">
            <p>
              <strong>Dr Amy Khor</strong>
            </p>

            <ul className="mb-6">
              <li>
                <strong>Head Judge of 2025 Sustainability Impact Awards</strong>
              </li>
              <li>
                <strong>Former Senior Minister of State</strong>
              </li>
              <li>
                <strong>Republic of Singapore </strong>
              </li>
            </ul>

            <p>
              Dr Amy Khor retired from politics after 24 years of service in May
              2025.
            </p>
            <p>
              She was a five term Member of Parliament from 2001 to 2025. During
              her service in politics, she has held various political
              appoiontments as Mayor fo South West District, Senior
              Parliamentary Secretary, Minister of State and Senior Minister of
              State at the then Ministry of the Environment and Water Resources
              which has been renamed to Ministry of Sustainability and the
              Environment. Ministry of Health, Ministry of Manpower and Ministry
              of Transport. Her last appointments were as Senior Minister of
              State for the Ministry of Sustainabilty and the Environment and
              Ministry of Transport. She served a total of 15 years in the then
              Ministry of the Environment and Water Resources from 2006 to 2010
              and then at the Ministry of Sustainability and Environment from
              2015 to 2025.
            </p>
            <p>
              She has been appointed ast the Honorary Advisor of the Singapore
              Institute of Surveyors and Valuers (SISV) since April 2025.
            </p>
            <p>
              Dr Khor holds a PhD in Land Management from the University of
              Reading, UK.
            </p>
          </Column>
        </Row>
      </AccordionV2>

      <AccordionV2
        testId="judges-chenHuifen-accordion"
        className="border-x border-gray-175 bg-gray-150 py-4"
        headerChildren={<EventsAwardsAccordionHeader title="Ms Chen Huifen" />}
        arrowClassName="border-none h-auto w-auto pr-6"
      >
        <Row rootClassName="flex flex-col md:flex-row w-full pt-4 mt-4 border-t border-gray-175 px-6 mx-0">
          <Column rootClassName="w-2/3 md:w-2/12 px-0 md:pr-3">
            <img src={chenHuifen} alt="Ms Chen Huifen" />
          </Column>

          <Column rootClassName="md:w-10/12 px-0 pt-4 md:pt-0 md:pl-3">
            <ul className="mb-6">
              <li>
                <strong>Ms Chen Huifen</strong>
              </li>
              <li>
                <strong>Editor, The Business Times</strong>
              </li>
            </ul>

            <p>
              Chen Huifen started her career with SPH Media in the digital
              realm, initially as a content producer for BT Online, before
              branching out to become a journalist. She left in 2002 to teach
              English and International Understanding in rural Japan, only to
              realise that she missed the newsroom buzz. Post-Sars, she returned
              to The Business Times to develop a new beat in biomedical sciences
              for the publication. Other than tracing Singapore&apos;s R&D
              drive, she has also covered technology, macroeconomics, government
              policy, and healthcare. She has also overseen the Young Investor
              Forum as well as the SME sections of the paper. She is the
              founding editor of BT&apos;s bimonthly The SME Magazine in 2010.
              Huifen switched to a full-time supervisory role in 2014 and in the
              past one and a half years, helped Wei Kong and other key members
              of the leadership team to steer the newsroom into adopting a
              digital-first mindset.
            </p>
          </Column>
        </Row>
      </AccordionV2>

      <AccordionV2
        testId="judges-geoffrey-accordion"
        className="border-x border-gray-175 bg-gray-150 py-4"
        headerChildren={<EventsAwardsAccordionHeader title="Mr Geoffrey Yeo" />}
        arrowClassName="border-none h-auto w-auto pr-6"
      >
        <Row rootClassName="flex flex-col md:flex-row w-full pt-4 mt-4 border-t border-gray-175 px-6 mx-0">
          <Column rootClassName="w-2/3 md:w-2/12 px-0 md:pr-3">
            <img src={geoffrey} alt="Mr Geoffrey Yeo" />
          </Column>

          <Column rootClassName="md:w-10/12 px-0 pt-4 md:pt-0 md:pl-3">
            <ul className="mb-6">
              <li>
                <strong>Mr Geoffrey Yeo</strong>
              </li>
              <li>
                <strong>
                  Assistant Managing Director, Capabilities, Urban Systems &
                  Solution, Enterprise Singapore
                </strong>
              </li>
            </ul>

            <p>
              Geoffrey serves as Assistant Chief Executive Officer at Enterprise
              Singapore, the government agency under the Ministry of Trade and
              Industry responsible for championing enterprise development. He
              oversees the Urban Solutions, Sustainability and Enterprise
              Finance portfolios.
            </p>
            <p>
              Prior to his current appointment, Geoffrey has previously held
              Director positions heading various portfolios in areas such as
              Strategy, Corporate Planning, Incentive Management, SME Financing
              and Startup Investments.
            </p>
            <p>
              He was the General Manager and currently on the Board of SEEDS
              Capital Pte Ltd, the investment arm of Enterprise Singapore which
              directs investments into Singapore-based technology startups in
              emerging and strategic sectors.
            </p>
            <p>
              Before joining the public service, Geoffrey spent several years in
              the private sector, with experience across finance and business
              development functions.
            </p>
            <p>
              He received the Public Service Administration Medal (Silver) in
              2023.
            </p>
          </Column>
        </Row>
      </AccordionV2>

      <AccordionV2
        testId="judges-lawrence-accordion"
        className="border-x border-gray-175 bg-gray-150 py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Professor Lawrence Loh" />
        }
        arrowClassName="border-none h-auto w-auto pr-6"
      >
        <Row rootClassName="flex flex-col md:flex-row w-full pt-4 mt-4 border-t border-gray-175 px-6 mx-0">
          <Column rootClassName="w-2/3 md:w-2/12 px-0 md:pr-3">
            <img src={lawrence} alt="Professor Lawrence Loh" />
          </Column>

          <Column rootClassName="md:w-10/12 px-0 pt-4 md:pt-0 md:pl-3">
            <ul className="mb-6">
              <li>
                <strong>Professor Lawrence Loh</strong>
              </li>
              <li>
                <strong>
                  Director, Centre for Governance and Sustainability, Professor,
                  Strategy and Policy, NUS Business
                </strong>
              </li>
              <li>
                <strong>School, National University of Singapore</strong>
              </li>
            </ul>

            <p>
              Prof Lawrence Loh is Director, Centre for Governance and
              Sustainability (CGS) at NUS Business School, National University
              of Singapore where he is Professor in Practice of Strategy and
              Policy. He is concurrently Visiting Professor at Wealth Management
              Institute (WMI), Singapore.
            </p>
            <p>
              Prof Loh received a PhD in Management from the Massachusetts
              Institute of Technology. His thesis on technology governance was
              awarded global first prize in the worldwide doctoral competition
              in the field of management information systems.
            </p>
            <p>
              At CGS, Prof Loh leads Environment, Social and Governance (ESG)
              initiatives, including the Sustainability Reporting Review as
              commissioned by the Singapore Exchange. He spearheads
              sustainability studies in ASEAN and Asia Pacific markets. Prof Loh
              also directs strategic studies in ESG themes such as sustainable
              banking, climate reporting and nature reporting. He steers the
              Singapore Governance and Transparency Index and ASEAN Corporate
              Governance Scorecard.
            </p>
            <p>
              Prof Loh is a regular commentator on business and policy issues
              for leading global and Singapore media. He achieves media mention
              count of some 600 annually. He had served as consultant for
              Fortune 500 companies and international organisations and actively
              conducts executive training and development for global and local
              clients.
            </p>
            <p>
              Prof Loh is a winner of the NUS Annual Teaching Excellence Award
              and the NUS Business School Teaching Excellence Award.
            </p>
          </Column>
        </Row>
      </AccordionV2>

      <AccordionV2
        testId="judges-lawrence-accordion"
        className="border-x border-gray-175 bg-gray-150 py-4"
        headerChildren={<EventsAwardsAccordionHeader title="Ms Eliza Tan" />}
        arrowClassName="border-none h-auto w-auto pr-6"
      >
        <Row rootClassName="flex flex-col md:flex-row w-full pt-4 mt-4 border-t border-gray-175 px-6 mx-0">
          <Column rootClassName="w-2/3 md:w-2/12 px-0 md:pr-3">
            <img src={elizaTan} alt="Ms Eliza Tan" />
          </Column>

          <Column rootClassName="md:w-10/12 px-0 pt-4 md:pt-0 md:pl-3">
            <ul className="mb-6">
              <li>
                <strong>Ms Eliza Tan</strong>
              </li>
              <li>
                <strong>Senior Vice President ,</strong>
              </li>
              <li>
                <strong>Head, IPO Admissions</strong>
              </li>
              <li>
                <strong>Head, Sustainable Development Office</strong>
              </li>
            </ul>

            <p>
              Ms Eliza Tan heads up the IPO Admissions function and Sustainable
              Development Office at Singapore Exchange Regulation (SGX RegCo), a
              subsidiary of Singapore Exchange Limited. SGX RegCo undertakes
              frontline regulation of the Singapore capital markets. Her roles
              include reviewing applications to list on the Official Lists of
              SGX-ST Mainboard and Catalist, promoting disclosure of reliable
              and comparable sustainability-related information, as well as
              capability building initiatives in advancing sustainability
              performance of listed issuers. Prior to this, Eliza had years of
              practical experience in reviewing listed issuers&apos; corporate
              disclosures and corporate actions. Eliza is a member of
              ISCA&apos;s Sustainability Reporting Standards Sub-Committee.
            </p>
          </Column>
        </Row>
      </AccordionV2>

      <AccordionV2
        testId="judges-lawrence-accordion"
        className="border-x border-gray-175 bg-gray-150 py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Mr Tan Swee Yiow" />
        }
        arrowClassName="border-none h-auto w-auto pr-6"
      >
        <Row rootClassName="flex flex-col md:flex-row w-full pt-4 mt-4 border-t border-gray-175 px-6 mx-0">
          <Column rootClassName="w-2/3 md:w-2/12 px-0 md:pr-3">
            <img src={tanSeeYiow} alt="Mr Tan Swee Yiow" />
          </Column>

          <Column rootClassName="md:w-10/12 px-0 pt-4 md:pt-0 md:pl-3">
            <ul className="mb-6">
              <li>
                <strong>Mr Tan Swee Yiow</strong>
              </li>
              <li>
                <strong>
                  President of REDAS, Real Estate Developers&apos; Association
                  of Singapore (REDAS)
                </strong>
              </li>
            </ul>

            <p>
              Mr Tan is the Chairman of Keppel REIT Management Limited (the
              Manager of Keppel REIT) and is on the board of Bukit Sembawang
              Estates Limited. He was Senior Managing Director of Real Estate at
              Keppel Ltd (f.k.a. Keppel Corporation) and Chief Executive Officer
              and Director of Keppel Management Ltd (f.k.a Keppel Land).
            </p>
            <p>
              The environmentalist in Mr Tan plays out in the company&apos;s
              sustainability track record, with more than 80 buildings garnering
              national green awards and certification. Keppel Land was also
              ranked fourth in Corporate Knights&apos; Global 100 Most
              Sustainable Corporations in the World in 2015. Mr Tan&apos;s
              commitment to decarbonising the built environment lands him
              onboard the World Green Building Council as a board director.
              Closer to home, Mr Tan is the Honorary Advisor of the Singapore
              Green Building Council.
            </p>
            <p>
              Mr Tan is currently the President of Real Estate Developers&apos;
              Association of Singapore. He concurrently serves as Deputy
              Chairman of the Workplace Safety and Health Council (Construction
              and Landscape Committee).
            </p>
          </Column>
        </Row>
      </AccordionV2>

      <AccordionV2
        testId="judges-lawrence-accordion"
        className="border-x border-gray-175 bg-gray-150 py-4"
        headerChildren={<EventsAwardsAccordionHeader title="Ms Theresa Goh" />}
        arrowClassName="border-none h-auto w-auto pr-6"
      >
        <Row rootClassName="flex flex-col md:flex-row w-full pt-4 mt-4 border-t border-gray-175 px-6 mx-0">
          <Column rootClassName="w-2/3 w-2/3 md:w-2/12 px-0 md:pr-3">
            <img src={theresa} alt="Ms Theresa Goh" className="img-fluid" />
          </Column>

          <Column rootClassName="md:w-10/12 px-0 pt-4 md:pt-0 md:pl-3">
            <ul className="mb-6">
              <li>
                <strong>Ms Theresa Goh</strong>
              </li>
              <li>
                <strong>Managing Founder, 360 Dynamics Limited</strong>
              </li>
            </ul>

            <p>
              Theresa Goh has over 25 years of experience in Business Management
              and Nonprofit stewardship in Asia.
            </p>
            <p>
              She began her career as a software engineer and global account
              manager with IBM. She has since reinvented herself to help
              organisations across public, private, and nonprofit sectors build
              human, knowledge, and social capital. She is also a passionate
              advocate of strong corporate governance.
            </p>
            <p>
              Through her specialisation in organisational behaviours and
              leadership dynamics, she founded 360 Dynamics, guiding over 1000
              senior leaders and executives across MNCs, SMEs, private equity
              and nonprofits. She is also a strategic associate with the Centre
              for Creative Leadership and Global Coach Group.
            </p>
            <p>
              In the nonprofit space, she is Chairperson of the Charity Council
              (MCCY), a board member of the Agency for Integrated Care (MOH),
              the National Council for Social Service (MSF), a Senior Accredited
              Director and Fellow of the Singapore Institute of Directors.
            </p>
            <p>
              She previously chaired the Board of SATA CommHealth and The Centre
              for Nonprofit Leadership.
            </p>
            <p>
              In 2021, she authored a book &apos;Leading for Good&apos; where
              she guides public, private, and nonprofit leaders to collaborate
              through defining a collective purpose.
            </p>
          </Column>
        </Row>
      </AccordionV2>
    </div>
  );
};
export default SIAJudgesPage;
